import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BrokeNotificationMutationKeys } from '../../../keys'
import { deleteBrokeNotification } from '../../services'

interface UseMutationDeleteBrokeNotificationProps {
	id: string
}

export default function useMutationDeleteBrokeNotification(
	props?: UseBaseMutationOptions<void, UseMutationDeleteBrokeNotificationProps>,
) {
	return useMutation({
		mutationKey: [BrokeNotificationMutationKeys.DeleteBrokeNotification],
		mutationFn: ({ id }) => deleteBrokeNotification(id),
		...props,
	})
}
